import styled from '@emotion/styled';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';

function FaqLiveagentPrompt(props: BaseMsgProps) {
  const { faqLiveagentPromptContent } = props.raw;

  const getLangText = useGetLangText();

  if (!faqLiveagentPromptContent) {
    return <></>;
  }

  return (
    <MessageExtendComplex
      {...props}
      content={<Container>{getLangText(faqLiveagentPromptContent.liveAgentText)}</Container>}
    />
  );
}

export function useGetLangText() {
  const lang = useSystemLanguageValue();

  const langMap: Record<General.SystemLanguage, string> = {
    'zh-CN': 'zh-Hans',
    'en-US': 'en',
    id: 'id',
    tl: 'fil',
    th: 'th',
    es: 'es-ES',
    vi: 'vi',
    pt: 'pt-BR',
  };

  return (langTextList: { lang: string; text: string }[]) => {
    return (
      (
        langTextList.find((_) => _.lang === langMap[lang]) ||
        langTextList.find((_) => _.lang === 'en') ||
        langTextList.find((_) => _.lang === 'zh-Hans') ||
        langTextList[0]
      )?.text || '-'
    );
  };
}

const Container = styled.div`
  max-width: 450px;
  padding: 8px 12px;
  border-radius: 4px;
  background: var(--fett-bg-panel);
`;

export default FaqLiveagentPrompt;
